import React from 'react'
import { ModalConsumerProps, NotificationType, withModal } from 'view/shared/modal'
import { ActionsButtonProps } from 'view/components/datagrid'
import { CollateralBasketDetail, CollateralBasketStatus, OrderActions, OrderAttributesCreateSource, OrderCreateArgs } from 'api'
import { Locale, Translation } from 'locale'
import { ActionItem, SplitButtonDropdown } from 'view/components/menus'
import styled from '@emotion/styled'
import { leftNavigationIconSet } from 'view/shared/leftNavigation'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { NotificationActions, ShowGrowlArgs } from 'store/notification'
import { newEmptyOrderAttributes } from 'model'
import { SelectFundDialog } from './SelectFundDialog'
import { createFundListByInstrumentSelector } from 'selectors/tradingEntitySelectors'
import { ReadOnlyCollateralBasketDetailsDialog } from 'view/shared/collateralBasket'

interface CollateralBasketActionsButtonProps extends ModalConsumerProps, ActionsButtonProps<CollateralBasketDetail> {
  onCreateOrder: (args: OrderCreateArgs) => unknown
  availableFunds: string[]
  onShowGrowl: (growlArgs: ShowGrowlArgs) => unknown
}

export const IconWrapper = styled.div`
  margin-left: 10px;
  display: flex;
  cursor: pointer;
`

const fundBuiSelector = (_: {}, props: CollateralBasketActionsButtonProps) => props.items[0].collateralBasket.id

const mapStateToProps = createStructuredSelector({
  availableFunds: createFundListByInstrumentSelector(fundBuiSelector)
})

const mapDispatchToProps = {
  onCreateOrder: OrderActions.create,
  onShowGrowl: NotificationActions.showGrowl
}

const CollateralBasketActionsButtonComponent: React.FunctionComponent<CollateralBasketActionsButtonProps> = props => {
  const { items, isGroupRow, onCreateOrder, onShowGrowl, availableFunds, showModal } = props

  const onStageBasketOrder = (basketId: string, fundId: string) => {
    const orderAttributes = newEmptyOrderAttributes(
      {
        basketId,
        fundId
      },
      null,
      null,
      null,
      OrderAttributesCreateSource.STAGE_BASKET
    )

    onCreateOrder({
      orderAttributes: [orderAttributes],
      deleteCurrentOrdersInStaging: false,
      spreadsheetContent: null,
      ignoreAxeId: null,
      performUserValidations: false
    })

    onShowGrowl({
      type: NotificationType.Success,
      title: Translation.TC_NOTIFICATION_SUCCESS,
      message: Translation.SC_NOTIFICATION_RFQ_PLACED_SUCCESS,
      timeout: 5000
    })
  }

  const stageBasketOrders = (selectedItem: CollateralBasketDetail) => {
    if (availableFunds.length === 1) {
      onStageBasketOrder(selectedItem.collateralBasket.id, availableFunds[0])
    } else {
      // Not all baskets have a single fund that the order can be placed to so show a dialog asking user to select
      showModal(<SelectFundDialog collateralBasket={selectedItem.collateralBasket} onStageBasketOrder={onStageBasketOrder} />)
    }
  }

  const showBasketDetails = (selectedItems: CollateralBasketDetail[]) => {
    showModal(<ReadOnlyCollateralBasketDetailsDialog collateralBasketDetail={selectedItems[0]} />)
  }

  const actions: ActionItem[] = [
    {
      label: Locale.translate(Translation.TC_ACTION_STAGE),
      onClick: () => stageBasketOrders(items[0]),
      // TODO remove the isDynamicBasket check once dynamic baskets are supported
      enabled:
        items.length === 1 &&
        items[0].collateralBasket.status === CollateralBasketStatus.ACTIVE &&
        !items[0].collateralBasket.isDynamicBasket
    }
  ]

  return (
    <>
      <SplitButtonDropdown autoHideEllipsis={true} actions={actions} maxButtons={1} />
      {!isGroupRow && <IconWrapper onClick={() => showBasketDetails(items)}>{leftNavigationIconSet.basketIcon}</IconWrapper>}
    </>
  )
}

export const CollateralBasketActionsButton = withModal(connect(mapStateToProps, mapDispatchToProps)(CollateralBasketActionsButtonComponent))
